import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useBlockingActivity } from 'Features/home/api/getBlockingActivity'
import React, { useMemo } from 'react'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { getCountryLabelByCountryValue, toUnixDateRangeFix } from 'Utils/dates'
import { BlockingActivityPmStyled } from './BlockingActivityPm.styled'
import { TrialPreEndModalCard } from '../../TrialPreEndModal.styled'
import { useTranslation } from 'react-i18next'
import { TrialPreEndModalCardText } from '../../PaidMarketingData/PaidMarketingData.styled'
import { Options, SeriesOptionsType } from 'highcharts'
import { DrillDownPie } from '@clickcease/cc-client-components-lib'

export const BlockingActivityPm = () => {
  const { data: plansDetails } = useGetPlansDetails()
  const { timezoneCountry } = useUserStore()
  const timezone: string = getCountryLabelByCountryValue(timezoneCountry)
  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })
  const { t } = useTranslation('accountSettings')

  const { data: blockingActivity } = useBlockingActivity(!!timezoneCountry && !!plansDetails, {
    startDate: serverDateConversion?.from,
    endDate: serverDateConversion?.to,
    timezone: timezone,
  })

  type BlockingActivityDataItem = {
    name: string
    y: number
  }

  const blockingData = useMemo(() => {
    const data: Array<BlockingActivityDataItem> = []
    let totalBlocking = 0
    if (blockingActivity) {
      for (const [key, value] of Object.entries(blockingActivity)) {
        if (typeof value === 'number') {
          totalBlocking += value
          data.push({
            name: key,
            y: value,
          })
        }
      }
    }
    return { graph: data, total: totalBlocking }
  }, [blockingActivity])

  const chartOptions: Options = {
    chart: {
      type: 'pie',
      height: 125,
      width: 320,
    },
    series: [
      {
        name: t('trial_pre_end_modal.threats_groups_types'),
        colorByPoint: true,
        type: 'pie',
        size: '80',
        marginTop: 0,
        marginBottom: 0,
        innerSize: '65%',
        data: blockingData.graph,
      } as SeriesOptionsType,
    ],
    legend: {
      useHTML: false,
      verticalAlign: 'middle',
      itemMarginBottom: 6,
      align: 'right',
      itemStyle: { fontSize: '13px', fontWeight: '300' },
    },
    tooltip: {
      enabled: true,
      outside: false,
      useHTML: true,
      style: {
        zIndex: 100,
      },
    },
  }

  return (
    <TrialPreEndModalCard>
      <TrialPreEndModalCardText>
        {t('trial_pre_end_modal.total_blocking_activity')} <span>{blockingData.total}</span>
      </TrialPreEndModalCardText>
      <BlockingActivityPmStyled>
        <DrillDownPie
          labelOptions={{ hidePercentage: true }}
          options={chartOptions}
          chartCSS={{ maxWidth: '301px', height: '100%' }}
          data={blockingData.graph}
        />
      </BlockingActivityPmStyled>
    </TrialPreEndModalCard>
  )
}
